import { container } from "tsyringe";
export class UseCaseGetLocationsByName {
    async handle(name) {
        const getLocationsByName = container.resolve("iGetLocationsByName");
        const locations = await getLocationsByName.getLocationsByName(name);
        return locations;
    }
}
export default UseCaseGetLocationsByName;
